import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';

export const InvalidPurseNumberText = ({ intl }) => iFMessage({intl, id: 'profile.error.invalid-purse'});

export const BlockChangesText = () => <FMessage id='slaves.payments-data.block-changes'/>;

export const WmzEmptyText = () => <FMessage id='payment-data.wallets.wmz.empty'/>;

export const AddBtn = ({ handleSave, disabled }) => (
  <Button type="button" color="primary" onClick={handleSave} disabled={disabled}>
    <FMessage id="main.add" />
  </Button>
);

export const ChangeBtn = () => (
  <Button type="button" color="primary" disabled>
    <FMessage id="main.change" />
  </Button>
);

export const DeleteBtn = ({ isSlave, handleDelete, id, type }) => (
  <Button type="button" color="primary" disabled={isSlave} onClick={() => handleDelete(id, type)}>
    <FMessage id="main.delete" />
  </Button>
);

export const GetCodeBtn = ({ handleSubmit, disabled, isChangingWallet, addLabel }) => (
  <Button type="button" color="primary" onClick={handleSubmit} disabled={disabled}>
    {addLabel ? (
      <FMessage id="main.add" />
    ) : isChangingWallet ? (
      <FMessage id="payment-data.wallets.code-gen.label.new" />
    ) : (
      <FMessage id="payment-data.wallets.code-gen.get" />
    )}
  </Button>
);

export const SupportTextComponent = () => (
  <Fragment>
    <FMessage id="profile.change_possible"/>
    {' '}
    <Link to="/tickets/create">
      <FMessage id="profile.support" />
    </Link>
  </Fragment>
);

export const AfterApprovePhoneTextComponent = () => (
  <Fragment>
    <FMessage id='payment-data.wallets.two-auth-confirmation.p-1'/>
    <FMessage id='payment-data.wallets.two-auth-confirmation.p-2'/>
    <Link to="/profile/security">
      <FMessage id='payment-data.wallets.two-auth-confirmation.p-3'/>
    </Link>
  </Fragment>
);

export const CodeGenTextLinkComponent = ({ onClick, type }) => {
  const handleClick = e => {
    e.preventDefault();
    onClick();
  };
  return (
    <Fragment>
      <a href='' onClick={handleClick}>
        <FMessage id={`payment-data.wallets.code-gen.label.new`}/>
      </a>{' '}
      <FMessage id={`payment-data.wallets.code-gen.${type}`}/>
    </Fragment>
  );
};

export const CodeGenTextComponent = ({type}) => (
  <Fragment>
    <FMessage id={`payment-data.wallets.code-gen.new.${type}`}/>
  </Fragment>
);

export const RegesterWithEPayments = () => {
  return (
      <a href='https://my.epayments.com/#/registration' target='_blank'>
        <FMessage id="payment-data.wallets.epayments.register"/>
      </a>
  );
};
